import user from './user';
import inbox from './inbox';
import modules from './modules';
import integrations from './integrations';
import company from './company';
import tour from './tour';
import notification from './notification';

export default {
	user,
	inbox,
	modules,
	integrations,
	company,
	tour,
	notification,
};
